export default {
  // Header
  "title": "ランダムポケモンジェネレーター",
  "subtitle": "あなたの好みに基づいてランダムなポケモンを生成します",
  "home": "ホーム",
  "whichPokemonAmI": "私はどのポケモン？",
  "aboutUs": "私たちについて",
  "contactUs": "お問い合わせ",
  "privacyPolicy": "プライバシーポリシー",
  
  // Filters
  "filterTitle": "フィルターオプション",
  "generateButton": "ランダムポケモンを生成",
  "generating": "生成中...",
  "numberOfPokemon": "ポケモンの数",
  "type": "タイプ",
  "generation": "世代",
  "minimumRarity": "最小レア度 (1-10)",
  "anyType": "任意のタイプ",
  "anyGeneration": "任意の世代",
  "anyRarity": "任意のレア度",
  "countingPokemon": "一致するポケモンを数えています",
  "matchingPokemonCount": "{{count}}匹のポケモンがあなたのフィルターに一致します",
  
  // Pokemon Types
  "normal": "ノーマル",
  "fire": "ほのお",
  "water": "みず",
  "electric": "でんき",
  "grass": "くさ",
  "ice": "こおり",
  "fighting": "かくとう",
  "poison": "どく",
  "ground": "じめん",
  "flying": "ひこう",
  "psychic": "エスパー",
  "bug": "むし",
  "rock": "いわ",
  "ghost": "ゴースト",
  "dragon": "ドラゴン",
  "dark": "あく",
  "steel": "はがね",
  "fairy": "フェアリー",
  
  // Generations
  "Generation I": "第一世代",
  "Generation II": "第二世代",
  "Generation III": "第三世代",
  "Generation IV": "第四世代",
  "Generation V": "第五世代",
  "Generation VI": "第六世代",
  "Generation VII": "第七世代",
  "Generation VIII": "第八世代",
  "Generation IX": "第九世代",
  
  // Evolution Stage
  "evolutionStage": "進化段階",
  "evolutionStageAll": "すべての段階",
  "evolutionStageFullyEvolved": "最終進化",
  "evolutionStageNotFullyEvolved": "未進化",
  
  // About Section
  "aboutTitle": "ランダムポケモンジェネレーターについて",
  
  // Section titles
  "introTitle": "ランダムポケモンジェネレーターへようこそ",
  "howToUseTitle": "ランダムポケモンジェネレーターの使い方",
  "benefitsTitle": "ランダムポケモンジェネレーターの利点",
  "historyTitle": "ポケモンの歴史",
  "popularPokemonTitle": "人気のポケモン",
  "popularGamesTitle": "人気のポケモンゲーム",
  "tradingContestsTitle": "ポケモン交換とコンテスト",
  "faqTitle": "よくある質問",
  "conclusionTitle": "今日からランダムポケモンの冒険を始めよう！",
  
  // Footer
  "copyright": "© 2025 randompokemon.games",
  "trademark": "ポケモンおよびポケモンのキャラクター名は任天堂の商標です。",
  "linksTitle": "リンク",
  
  // About Us Page
  "aboutUsTitle": "私たちについて",
  "aboutUsWhoWeAre": "私たちは誰か",
  "aboutUsWhoWeAreContent1": "ランダムポケモンジェネレーターへようこそ。これは熱心なポケモンファンによって作られたファンメイドツールです。私たちの旅は2023年に始まり、プログラミングとポケモンの両方を愛する開発者のグループがコミュニティのために役立つツールを作ることを決めました。",
  "aboutUsWhoWeAreContent2": "私たちのチームは、世界中のポケモンファンに最高の体験を提供するために協力する開発者、デザイナー、コンテンツクリエイターで構成されています。",
  "aboutUsOurMission": "私たちの使命",
  "aboutUsOurMissionContent1": "私たちは、ポケモンの世界をすべての人にとってよりアクセスしやすく、楽しいものにすることを目指しています。私たちのツールは、トレーナーが新しいポケモンを発見し、バランスの取れたチームを作成し、完璧なポケモンマッチを見つけるのを支援するために設計されています。",
  "aboutUsOurMissionContent2": "私たちは、ポケモンフランチャイズを尊重しながらコミュニティに価値を付加する、ユーザーフレンドリーで正確かつ楽しい体験を提供することに取り組んでいます。",
  "aboutUsOurTeam": "私たちのチーム",
  "aboutUsOurTeamContent1": "私たちの多様なチームは、ウェブ開発、ポケモンの知識、ユーザー体験設計、およびコミュニティ管理の専門知識を集結させています。私たちはポケモンへの愛と高品質なツールを作成することへのコミットメントで結束しています。",
  "aboutUsOurTeamContent2": "各チームメンバーは、ランダムポケモンジェネレーターを最高のものにするために、彼らのユニークなスキルと視点を貢献しています。",
  "aboutUsJoinUs": "参加する",
  "aboutUsJoinUsContent": "私たちは常に、私たちのコミュニティに参加する情熱的な個人を探しています。あなたが開発者、デザイナー、ポケモンの専門家、または熱心なユーザーであるかどうかにかかわらず、あなたのフィードバックと貢献を歓迎します。",
  
  // Contact Us Page
  "contactUsTitle": "お問い合わせ",
  "contactUsGetInTouch": "連絡する",
  "contactUsGetInTouchContent": "ランダムポケモンジェネレーターについて質問、提案、またはフィードバックがありますか？私たちはあなたからの声を聞きたいと思っています！こちらが私たちのチームに連絡する方法です。",
  "contactUsEmail": "メール",
  "contactUsPhone": "電話",
  "contactUsAddress": "住所",
  "contactUsHelpSupport": "ヘルプ＆サポート",
  "contactUsHelpSupportContent": "私たちのツールの使用について支援が必要ですか、または問題が発生しましたか？サポートチームがお手伝いいたします。",
  "contactUsFAQ": "よくある質問",
  "contactUsFAQContent": "お問い合わせの前に、多くの一般的な質問と問題をカバーするFAQセクションをご確認ください。",
  "contactUsBugReport": "バグを報告する",
  "contactUsBugReportContent": "バグや技術的な問題を発見した場合は、件名に「バグレポート」と記載してメールでお知らせください。",
  
  // Privacy Policy Page
  "privacyPolicyTitle": "プライバシーポリシー",
  "privacyPolicyIntro": "はじめに",
  "privacyPolicyIntroContent": "ランダムポケモンジェネレーターでは、あなたのプライバシーを尊重し、個人データを保護することに取り組んでいます。このプライバシーポリシーは、あなたが私たちのウェブサイトを使用する際に私たちがどのように情報を収集、使用、保護するかを説明しています。",
  "privacyPolicyInformation": "収集する情報",
  "privacyPolicyInformationContent": "私たちは、サービスを提供および改善するために最小限の情報を収集しています。これには以下が含まれる場合があります：",
  "privacyPolicyInformationItem1": "使用データ（訪問したページ、サイト上での時間、使用した機能など）",
  "privacyPolicyInformationItem2": "デバイス情報（ブラウザの種類、オペレーティングシステム、画面解像度）",
  "privacyPolicyInformationItem3": "IPアドレスおよびおおよその位置（国レベルのみ）",
  "privacyPolicyCookies": "クッキーと同様のテクノロジー",
  "privacyPolicyCookiesContent": "私たちは、ウェブサイト上でのあなたの体験を向上させるためにクッキーを使用しています。これらの小さなテキストファイルにより、私たちはあなたの設定を記憶し、私たちのサイトの使用状況を分析することができます。クッキーはブラウザの設定を通じて制御できます。",
  "privacyPolicyThirdParty": "サードパーティサービス",
  "privacyPolicyThirdPartyContent": "私たちのウェブサイトでは、分析プロバイダーやコンテンツ配信ネットワークなどのサードパーティサービスを使用することがあります。これらのサービスは、あなたの私たちのウェブサイトの使用に関する情報を収集する場合があります。私たちは、すべてのサードパーティがあなたのプライバシーを尊重し、データを適切に処理することを確認しています。",
  "privacyPolicySecurity": "データセキュリティ",
  "privacyPolicySecurityContent": "私たちは、不正アクセス、変更、または開示からあなたの情報を保護するための適切なセキュリティ対策を実施しています。ただし、インターネット経由の送信は100％安全ではないため、絶対的なセキュリティを保証することはできません。",
  "privacyPolicyChanges": "このポリシーの変更",
  "privacyPolicyChangesContent": "私たちは、プライバシーポリシーを随時更新することがあります。このページに新しいプライバシーポリシーを掲載し、「最終更新日」を更新することで、変更についてお知らせします。",
  "privacyPolicyContact": "お問い合わせ",
  "privacyPolicyContactContent": "このプライバシーポリシーについて質問がある場合は、お問い合わせページに記載されている情報を通じてお問い合わせください。",
  "privacyPolicyLastUpdated": "最終更新日",

  // Which Pokemon Am I Page
  "whichPokemonAmITitle": "私はどのポケモン？",
  "whichPokemonAmISubtitle": "あなたに最も合ったポケモンを見つけましょう",
  "enterYourName": "あなたの名前を入力してください",
  "namePlaceholder": "あなたの名前",
  "enterFavoriteColor": "好きな色を選んでください",
  "enterBirthMonth": "誕生月を選んでください",
  "selectBirthMonth": "誕生月を選択",
  "enterPersonalityTrait": "性格特性を選んでください",
  "selectPersonalityTrait": "性格特性を選択",
  "findMyPokemon": "自分のポケモンを見つける",
  "calculating": "計算中...",
  "yourPokemonIs": "あなたのポケモンは",
  "pokemonDescription": "説明",
  "personalityMatch": "性格の一致度",
  "yourCompatibility": "あなたとの相性",
  "downloadImage": "画像をダウンロード",
  "shareResult": "結果をシェア",
  "tryAgain": "もう一度試す",
  "results": "結果",
  "aboutTool": "このツールについて",
  "howToUse": "使い方",
  "benefits": "メリット",
  "faq": "よくある質問",
  "conclusion": "まとめ",
  
  // Error messages
  "nameRequired": "名前は必須です",
  "colorRequired": "色を選んでください",
  "monthRequired": "月を選んでください",
  "traitRequired": "性格特性を選んでください",
  
  // Months
  "january": "1月",
  "february": "2月",
  "march": "3月",
  "april": "4月",
  "may": "5月",
  "june": "6月",
  "july": "7月",
  "august": "8月",
  "september": "9月",
  "october": "10月",
  "november": "11月",
  "december": "12月",
  
  // Personality Traits
  "brave": "勇敢",
  "calm": "穏やか",
  "timid": "臆病",
  "jolly": "陽気",
  "quiet": "静か",
  "hasty": "せっかち",
  "careful": "慎重",
  "lonely": "さみしがり",
  "bold": "大胆",
  "relaxed": "のんき",
  "impish": "わんぱく",
  "modest": "控えめ",
  
  // Size matching feature
  "enterHeightWeight": "身長と体重を入力して、あなたに合うポケモンを見つけましょう！",
  "whichPokemonMatchesSize": "あなたの体格に合うポケモンは？",
  "youAreMostLike": "あなたに最も似ているのは",
  "nameLabel": "名前",
  "heightLabel": "身長",
  "weightLabel": "体重",
  "heightValid": "有効な身長を入力してください（1～300 cm）",
  "weightValid": "有効な体重を入力してください（1～500 kg）",
  "enterDetails": "あなたの詳細を入力",
  "finding": "検索中...",
  "errorFinding": "ポケモンの検索中にエラーが発生しました",
  "matchResult": "{{name}}のポケモンは...",
  "similarityScore": "類似度スコア",
  "downloadStarted": "画像を準備中...",
  "downloadComplete": "画像が正常にダウンロードされました！",
  "shareText": "私は{{pokemon}}だとわかりました！あなたはどのポケモン？",
  "madeBy": "作成者",

  // New Page: Pokemon Randomizer - About Section Titles (Translated to Japanese)
  "pokemonRandomizerPageAboutTitle": "究極のポケモンランダマイザー体験を探る",
  "pokemonRandomizer_whatIsItTitle": "ポケモンランダマイザーとは具体的に何ですか？",
  "pokemonRandomizer_featuresTitle": "私たちのポケモンランダマイザーツールの主な特徴",
  "pokemonRandomizer_whyUseTitle": "なぜポケモンランダマイザーで冒険を始めるのですか？",
  "pokemonRandomizer_gettingStartedTitle": "はじめに：最初のポケモンランダマイザーラン",
  "pokemonRandomizer_faqTitle": "ポケモンランダマイザー：よくある質問",

  // New keys for PokemonRandomizerPage.tsx H1 and subtitle (Translated to Japanese)
  "pokemonRandomizerPageH1": "ポケモンランダマイザー",
  "pokemonRandomizerPageSubtitle": "高度なランダマイザーツールでユニークなポケモン体験を創造しましょう。",

  // Sub-Footer
  subFooterToolsTitle: "ツール",
  subFooterRandomPokemonGeneratorLink: "ランダムポケモンジェネレーター",
  subFooterPokemonRandomizerLink: "ポケモンランダマイザー",
  subFooterWhichPokemonAmILink: "どのポケモンですか？",

  subFooterPokemonDatabaseTitle: "ポケモンデータベース",
  subFooterPokedexLink: "ポケモン図鑑 (近日公開)",
  subFooterTypeChartsLink: "タイプ相性表 (近日公開)",
  subFooterMoveListLink: "技リスト (近日公開)",

  subFooterBlogTitle: "ブログ",
  subFooterLatestArticlesLink: "最新記事 (近日公開)",
  subFooterGuidesTutorialsLink: "ガイド＆チュートリアル (近日公開)"
};
